import { createHook } from '@atlassian/react-sweet-state';
import { Store } from '../../main.tsx';

export const useSavedFilters = createHook(Store, {
	selector: ({ savedFilters }) => savedFilters || [],
});
